import React from "react";

export default function User() {
	return (
		<div>
			<h1>User</h1>
		</div>
	);
}
